/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_HindiInputs */



/**
* | output |
* | --- |
* | "Hindi" |
*
* @param {Speechmatics_Target_Language_HindiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_hindi = /** @type {((inputs?: Speechmatics_Target_Language_HindiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_HindiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hindi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Hindi")
	if (locale === "it") return /** @type {LocalizedString} */ ("hindi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("хинди")
	if (locale === "es") return /** @type {LocalizedString} */ ("hindi")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("印地语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ヒンディー語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हिंदी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("hindi")
	return /** @type {LocalizedString} */ ("Hindi")
});